/**
 * Created by Andrey Popov on 25 june 2025
 */

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    WEEKLY_GOALS_ROW_TEXT: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    WEEKLY_GOALS_ATTENTION_TEXT: {
        name: "default",
        size: 30,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});

const WeeklyGoalsExtraBarIcon = {
    customIcon: function () {
        return Prefab.instantiate(bundles.weekly_goals_icon.jsons.weekly_goals_extrabar_icon_prefab_json, {});
    },
    extraBarWeight: 100004
};
